import React from "react";

import UniformsHome from "../components/HomeBanner";
import Stats from "../components/Stats";
import AboutUs from "../components/AboutUs";
import NasaPonuda from "../components/NasaPonuda";

export default function Home() {
  return (
    <div>
      <UniformsHome />
      <Stats />
      <AboutUs />
      <NasaPonuda />
    </div>
  );
}
